/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ExcelStyle } from 'ag-grid-enterprise';
import { useCallback } from 'react';
import { HighlightObject, getColor } from 'jotai/vehicleColor';

export const useFastestLapsTableExcelStyles = (newVehicleColors: HighlightObject, vehicleCellClassNames: string[]) => {
  const fastestLapsTableExcelStyles = useCallback(() => {
    const headerStyle: ExcelStyle = {
      id: 'header',
      borders: {
        borderBottom: {
          weight: 1,
          lineStyle: 'Continuous',
        },
      },
    };
    const rankColStyle: ExcelStyle = {
      id: 'rank',
      borders: {
        borderRight: {
          weight: 1,
          lineStyle: 'Continuous',
        },
      },
    };
    const diffColStyle: ExcelStyle = {
      id: 'diff',
      borders: {
        borderRight: {
          weight: 1,
          lineStyle: 'Continuous',
        },
      },
    };
    const highlightVehicleStyle = vehicleCellClassNames.map((vehicleCellClassName) => {
      const vehicleNumber = vehicleCellClassName.split('-')[3];
      if (Object.hasOwn(newVehicleColors, vehicleNumber)) {
        const backgroundColor = getColor(newVehicleColors[vehicleNumber], 'vehicle');
        return {
          id: vehicleCellClassName,
          interior: {
            color: backgroundColor.hex,
            pattern: 'Solid',
            patternColor: backgroundColor.hex,
          },
          font: {
            color: backgroundColor.contrastTextHex,
          },
        } as ExcelStyle;
      } else {
        return {
          id: vehicleCellClassName,
        };
      }
    });
    const cellStyle: ExcelStyle = {
      id: 'cell',
      alignment: {
        horizontal: 'Right',
      },
    };
    let output = [headerStyle, rankColStyle, diffColStyle, ...highlightVehicleStyle, cellStyle];
    return output;
  }, [newVehicleColors, vehicleCellClassNames]);
  return {
    fastestLapsTableExcelStyles,
  };
};
